/** Factory the app uses. OWNER: RENDER agent — return your implementation here (keep the name). */
import type { GameRenderer } from '../types';
import { Bo2Renderer } from './renderer';

export function createRenderer(): GameRenderer {
  return new Bo2Renderer();
}
